import type { ReactNode } from 'react'

import { cn } from '@/lib/utils/cn'

import { VoiceIcon, type VoiceIconName } from './icon'

interface ChipProps {
  active?: boolean
  onClick?: () => void
  children: ReactNode
  icon?: VoiceIconName
  /** 悬停提示（如标签 description） */
  hint?: string
}

/**
 * 胶囊筛选按钮（用于 Plaza tabs、LibraryMode filter 等）
 */
export const Chip = ({ active, onClick, children, icon, hint }: ChipProps) => (
  <button
    title={hint}
    type="button"
    className={cn(
      'inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border px-[13px] py-[7px] text-[12.5px] font-medium transition-all duration-150',
      active
        ? 'border-[var(--border-active)] bg-white/[0.08] text-[var(--text-1)]'
        : 'border-[var(--border)] bg-white/[0.02] text-[var(--text-2)]'
    )}
    onClick={onClick}
  >
    {icon && <VoiceIcon name={icon} size={13} />}
    {children}
  </button>
)
